import axios from 'axios';
import { getQueryParam } from "../shared/utilities";

const LoginUri = '/portal';
const UserUri = '/v3/users/0';
const CustomerUri = '/v3/customers';

const fetchXSRF = key => {
  key += '=';
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < cookies.length; i += 1) {
      const cookie = cookies[i].trim();
      if (cookie.startsWith(key)) {
        cookieValue = decodeURIComponent(cookie.replace(key, ''));
        break;
      }
    }
  }
  return cookieValue;
};

export default {
  isAuthenticated() {
    return axios.get(UserUri, { headers: { 'x-xsrf-token': fetchXSRF('xsrf') } });
  },
  sendResetPasswordMail(email) {
    return axios.post(`${LoginUri}/password-reset-token`, { email });
  },
  createUser(username, password) {
    const token = 'Basic ' + btoa(username + ':' + password);
    return axios.post(`${LoginUri}/session`, {}, { headers: { Authorization: token } });
  },
  setNewPassword(password) {
    const token = getQueryParam("token"); //z9v3plJCLLK4xTpArvsVgjhDs1vSmHHrZIAkszpC7bM
    return axios.post(
      `${LoginUri}/password`,
      { password },
      { headers: { Authorization: `Bearer ${token}` } }
    );
  },
  getCustomerData(customer) {
    return axios
      .get(`${CustomerUri}/${customer}`)
      .then((response) => response.data.data);
  },
};
